// Template styles.
import "../joomla/styles/template.scss";

// Modules.
import "pistacja/license-copy";
import pie from "pistacja/plugin";
import Cookies from "./pistacja/cookies";
import Feedback from "pistacja/feedback";
import { SystemMessages } from "pistacja/messages";

// Initialize plugins.
document.addEventListener("DOMContentLoaded", () => {
  pie.init(() => ({
    version: `v${PIE_VERSION}`,
    domain: document.querySelector("a.pie-logo").href,
  }));
});

// Main Plugin.
pie.plugin(async function Main({ $, lsm, domain }) {
  // Template version.
  console.log(`pi-stacja-template v${PIE_VERSION}`);

  // Handle system Messages.
  SystemMessages($);

  // Handle cookies.
  Cookies(lsm);

  // Install feedback button.
  const contact = $("#pie-contact-ref");
  if (contact) {
    Feedback({
      domain,
      classes: "mobile",
      root: $(".top-menu"),
      action: contact.href,
    });
    Feedback({
      domain,
      classes: "desktop",
      root: document.body,
      action: contact.href,
    });
  } else if (process.env.NODE_ENV !== "production") {
    console.warn("Feedback button not installed. Contact link not found.");
  }
});
